"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributeFilterSearch = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
/**
 * Use this hook if you want to implement your custom attribute filter search bar component.
 *
 * @beta
 */
exports.useAttributeFilterSearch = function (props) {
    var onSearch = props.onSearch, searchString = props.searchString;
    var _a = react_1.useState(searchString), search = _a[0], setSearch = _a[1];
    react_1.useEffect(function () {
        setSearch(searchString);
    }, [searchString]);
    var onSearchCallback = react_1.useCallback(function (search) {
        setSearch(search);
        onSearch(search);
    }, [onSearch]);
    return {
        onSearch: onSearchCallback,
        search: search,
    };
};
//# sourceMappingURL=useAttributeFilterSearch.js.map